var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { interpolate, useTranslations } from '.';
export var Text = function (_a) {
    var id = _a.id, interpolations = _a.interpolations, tag = _a.tag;
    var _b = __read(useTranslations(), 1), translations = _b[0];
    var string = translations[id];
    if (!string) {
        console.error("Couldn't find '" + id + "' in the translations table"); // eslint-disable-line no-console
        return null;
    }
    return React.createElement(React.Fragment, null, interpolate(string, interpolations, tag));
};
//# sourceMappingURL=text.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/text.js
// module id = 582
// module chunks = 0